import React, { useState, useMemo, useEffect } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { errorMsgRecoil } from '../atom/ModalAtom';
import { useNavigate } from 'react-router-dom';
import { userInforRecoilState } from '../atom/TokenAtom';
import { authAPI } from '../api/axiosIndex';
import { SignInDto } from '../model/user.dto';

const useTokenUpdate = () => {
  const setError = useSetRecoilState(errorMsgRecoil);

  const navigate = useNavigate();

  const tokenUpdate = async () => {
    try {
      const newToken = await authAPI.getNewToken(
        String(sessionStorage.getItem('refreshToken')),
      );
      sessionStorage.setItem('accessToken', newToken.data.accessToken);
      sessionStorage.setItem('refreshToken', newToken.data.refreshToken);
      sessionStorage.setItem(
        'accessExpire',
        (Date.now() + newToken.data.accessExpire * 1000).toString(),
      );
      sessionStorage.setItem(
        'refreshExpire',
        (Date.now() + newToken.data.refreshExpire * 1000).toString(),
      );
    } catch (err) {
      const userInfor = JSON.parse(String(localStorage.getItem('userInfor')));

      if (userInfor) {
        const dto: SignInDto = {
          passid: userInfor.passid,
          password: userInfor.password,
        };

        const token = await authAPI.signIn(dto);

        sessionStorage.setItem('accessToken', token.data.accessToken);
        sessionStorage.setItem('refreshToken', token.data.refreshToken);
        sessionStorage.setItem(
          'accessExpire',
          (Date.now() + token.data.accessExpire * 1000).toString(),
        );
        sessionStorage.setItem(
          'refreshExpire',
          (Date.now() + token.data.refreshExpire * 1000).toString(),
        );
      } else {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/login');
        setError('로그인 세션이 만료되었습니다.\n다시 로그인해 주세요.');
      }
    }
  };

  useEffect(() => {
    const checkAndUpdateToken = () => {
      const accessToken = sessionStorage.getItem('accessToken');

      if (accessToken) {
        tokenUpdate();
      }
    };

    const interval = setInterval(checkAndUpdateToken, 50 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return null;
};

export default useTokenUpdate;
